const handleOptionalFieldErrors = ({ fieldName, fieldValue, targetName, targetValue }) =>
  (targetName === fieldName && targetValue === '') || (targetName !== fieldName && fieldValue === '');

export default handleOptionalFieldErrors;
